import { Button } from "@/components/ui/button";

interface LinkedInLinkNoticeProps {
  onConnect: () => void;
}

export const LinkedInLinkNotice = ({ onConnect }: LinkedInLinkNoticeProps) => (
  <div className="w-full relative bg-yiedl-gray-200 border-2 border-neutral-800 rounded-2xl p-6 md:p-8 shadow-lg">
    <div className="flex flex-col items-center gap-4 md:gap-6">
      {/* Icon */}
      {/* <div className="relative bg-yiedl-primary p-5 rounded-2xl shadow-md">
        <img
          src={ICONS.linkedin}
          alt="LinkedIn"
          width={32}
          height={32}
          className="md:w-10 md:h-10 object-contain"
          style={{ filter: "invert(1)" }}
        />
      </div> */}

      {/* Text content */}
      <div className="text-center space-y-2 md:space-y-3">
        <h3 className="text-lg md:text-xl font-bold text-white">
          Connect your LinkedIn account
        </h3>
        <p className="text-sm md:text-base text-gray-400 leading-relaxed max-w-md px-2">
          Connect your LinkedIn account to complete professional tasks and verify your participation.
        </p>
      </div>

      <Button
        onClick={onConnect}
        className="w-full max-w-sm bg-yiedl-primary hover:opacity-90 text-white font-semibold rounded-xl px-6 py-3 transition-all duration-200 ease-out text-sm md:text-base"
      >
        <span className="inline-flex items-center justify-center gap-2">
          {/* <img
            src={ICONS.linkedin}
            alt=""
            width={18}
            height={18}
            style={{ filter: "invert(1)" }}
          /> */}
          <span>Connect with LinkedIn</span>
        </span>
      </Button>
    </div>
  </div>
);
